export function mapCondicoesPagamentoFromApi(list) {
  if (!Array.isArray(list)) return [];
  return list
    .map((c) => ({
      idCondicaoPagamento: Number(c.IdCondicaoPagamento ?? c.idCondicaoPagamento),
      politica: (c.Politica ?? c.politica ?? "").trim(),
      percentualDesconto: c.PercentualDesconto ?? c.percentualDesconto ?? null,
      prazoMedio: c.PrazoMedio ?? c.prazoMedio ?? null,
      label: formatCondicaoPagamentoLabel(c),
    }))
    .filter((c) => c.idCondicaoPagamento > 0);
}

export function formatCondicaoPagamentoLabel(condition) {
  if (!condition) return "";
  const politica =
    (condition.Politica ?? condition.politica ?? "").trim() ||
    (condition.idCondicaoPagamento != null
      ? `Condição ${condition.idCondicaoPagamento}`
      : condition.IdCondicaoPagamento != null
        ? `Condição ${condition.IdCondicaoPagamento}`
        : "");
  const parts = [politica];
  const pct = condition.PercentualDesconto ?? condition.percentualDesconto;
  if (pct != null && pct !== "") {
    parts.push(`${pct}% desc.`);
  }
  const prazo = condition.PrazoMedio ?? condition.prazoMedio;
  if (prazo != null && prazo !== "") {
    parts.push(`${prazo} dias`);
  }
  return parts.join(" · ");
}

/** Condição mais usada nos itens da família já no carrinho (abertura da grade). */
export function resolveBulkPaymentIdFromFamilyCart(
  familyKey,
  orderState,
  paymentConditionState,
  condicoes,
  fallbackId,
) {
  if (!familyKey || !orderState) {
    return getDefaultCondicaoPagamentoId(condicoes, fallbackId);
  }
  const prefix = `${familyKey}_`;
  const counts = new Map();
  Object.entries(orderState).forEach(([key, qty]) => {
    if (!key.startsWith(prefix) || !qty || Number(qty) <= 0) return;
    const raw = paymentConditionState?.[key];
    if (raw == null || raw === "") return;
    const id = Number(raw);
    if (!id || Number.isNaN(id)) return;
    counts.set(id, (counts.get(id) || 0) + 1);
  });
  if (counts.size === 0) {
    return getDefaultCondicaoPagamentoId(condicoes, fallbackId);
  }
  let bestId = null;
  let bestCount = 0;
  counts.forEach((count, id) => {
    if (count > bestCount) {
      bestCount = count;
      bestId = id;
    }
  });
  return bestId;
}

export function getDefaultCondicaoPagamentoId(condicoes, fallbackId) {
  if (!Array.isArray(condicoes) || condicoes.length === 0) {
    const fb = Number(fallbackId);
    return fb > 0 ? fb : null;
  }
  if (condicoes.length === 1) return condicoes[0].idCondicaoPagamento;
  const fb = Number(fallbackId);
  if (fb > 0 && condicoes.some((c) => c.idCondicaoPagamento === fb)) {
    return fb;
  }
  return condicoes[0].idCondicaoPagamento;
}

export function findCondicaoPagamentoById(condicoes, id) {
  if (id == null || !Array.isArray(condicoes)) return null;
  const n = Number(id);
  return condicoes.find((c) => c.idCondicaoPagamento === n) || null;
}

export function getDiscountPercentFromCondicao(condicao, fallback = 0) {
  if (!condicao) return Number(fallback) || 0;
  const pct = condicao.percentualDesconto ?? condicao.PercentualDesconto;
  if (pct == null || pct === "") return Number(fallback) || 0;
  const n = Number(pct);
  return Number.isNaN(n) ? Number(fallback) || 0 : n;
}

/** Desconto efetivo do SKU conforme condição de pagamento selecionada. */
export function resolveLineDiscount(prod, fam, idCondicaoPagamento) {
  const fallback = Number(prod?.discount) || 0;
  const condicoes = fam?.condicoesPagamento || [];
  const cond = findCondicaoPagamentoById(condicoes, idCondicaoPagamento);
  if (cond) return getDiscountPercentFromCondicao(cond, fallback);
  return fallback;
}

export function netUnitPrice(prod, discountPercent) {
  const price = Number(prod?.price) || 0;
  const d = Number(discountPercent) || 0;
  return price * (1 - d / 100);
}
